import Collapse from 'bootstrap/js/dist/collapse'
import Search from "./components/search";

import Ajax from "./components/ajax";

//import handleMenu from "./components/menu";
//handleMenu();

Ajax.initiates();
